export enum API {
  LocalURL = 'http://127.0.0.1/api/v1',
  StagingURL = 'https://stag.api.ryddm.com/api/v1',
  ProductionURL = 'https://api.ryddm.com/api/v1',
}
